import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Report, RowActions } from '../../report';

import { KYCReportService } from '../../services/kyc-report.service';
import { KYCReportStatusService } from './kyc-report-status.service';

@Component({
	selector: 'app-kyc-report',
	templateUrl: './kyc-report.component.html',
	styleUrls: ['./kyc-report.component.scss']
})
export class KYCReportComponent implements OnInit {
	requestBody: Report = {};
	sellersArray: any[] = [];
	KYCData: any[] = [];
	totalNumberOfRecords: number = 0;
	bussinesId: number = 0;
	loading = false;
	tableColumns = [
		'BusinessId',
		'BusinessName',
		'Type',
		'Status',
		'TaxNumber',
		'LegalName',
		'NationalId',
		'NationalName',
	];
	displayTableColumns = {
		'BusinessId': 'Business Id',
		'BusinessName': 'Business Name',
		'Type': 'Type',
		'Status': 'Status',
		'TaxNumber': 'Business Tax Number',
		'LegalName': 'LegalName',
		'NationalId': 'NationalId',
		'NationalName': 'NationalName',
	};
	rowActions: RowActions[] = [{
		actionName: 'View',
		actionType: 'Button',
		actionClass: 'btn-primary',
	}];

	constructor(
		protected translate: TranslateService,
		public kyc: KYCReportService,
		private router: Router,
		private kycList: KYCReportStatusService,
	) { }

	async ngOnInit() {
		this.kyc.activateLoader();
		this.updateTable();
	}

	async updateTable() {
		this.kyc.activateLoader();
		this.kyc.setParams(this.requestBody);
		const report = await this.kyc.make();
		this.KYCData = report.result;
		this.totalNumberOfRecords = report.totalNumberOfRows;
		this.kycList.setData(this.KYCData.map(e => e.BusinessId));
	}

	async filter(event: any) {
		this.requestBody.filterOptions = {};
		if (event && Object.keys(event).length) {
			this.requestBody.filterOptions = event;
		}
		this.requestBody.paginationOptions = {
			start: 0,
			limit: 10
		};
		this.updateTable();
		this.kyc.loader().subscribe(val => (this.loading = val));
	}

	async paginate(event: any) {
		this.requestBody.paginationOptions = {
			start: event.pageIndex * event.pageSize,
			limit: event.pageSize
		};
		this.updateTable();
		this.kyc.loader().subscribe(val => (this.loading = val));
	}

	async searchChance(event: any) {
		if (event) {
			this.requestBody.searchOptions = {
				searchKey: event
			};
		} else {
			this.requestBody.searchOptions = undefined;
			this.kyc.loader().subscribe(val => (this.loading = val));
		}
		await this.updateTable();
	}

	async sortChange(event: any) {
		this.requestBody.sortOptions = {};
		if (event.direction !== '') {
			this.requestBody.sortOptions = {
				[`${event.active}`]: event.direction
			};
		}
		await this.updateTable();
		this.kyc.loader().subscribe(val => (this.loading = val));
	}

	actionsCB(event: any) {
		this.router.navigate([`admin/reports/kyc-report/${event.key.BusinessId}`]);
	}
}
